import HeaderBanner from 'components/HeaderBanner'
import Product from 'components/Product'
import { mapState } from 'vuex'
import { extractErrorMessage } from '@/utilities/common'

export default {
  components: {
    Product,
    HeaderBanner
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updatePageName(to.meta.pageName)
    })
  },

  data () {
    return {
      isLoading: true,
      specificDateFormat: null,
      resumedNextShippingDate: null
    }
  },

  computed: {
    ...mapState('subscription', ['subscriptionDetails'])
  },

  async created () {
    try {
      await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.$route.params.id)
      this.isLoading = false
      let resumedReplenishmentDate = this.subscriptionDetails && this.subscriptionDetails.resumedReplenishmentDate
      if (resumedReplenishmentDate) {
        this.specificDateFormat = `${new Date(resumedReplenishmentDate).toDateString().split(' ')[1]} ${new Date(resumedReplenishmentDate).getDate()}, ${new Date(resumedReplenishmentDate).getFullYear()}`
        this.resumedNextShippingDate = `${new Date(this.subscriptionDetails.nextShipmentDate).toDateString().split(' ')[1]} ${new Date(this.subscriptionDetails.nextShipmentDate).getDate()}, ${new Date(this.subscriptionDetails.nextShipmentDate).getFullYear()}`
      }
    } catch (error) {
      this.$notify({
        type: 'error',
        title: extractErrorMessage(error)
      })
    }
  }
}
